import { BaseService } from '../../../core/services/BaseServices';
import { AxiosPromise } from 'axios';

export class UserService extends BaseService {
  constructor() {
    super('user');
  }

  getSupervisor = (orgId: number | string) => {
    return this.httpAxios
      .get(`userBasicList/${orgId}`)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  public logout(): AxiosPromise<any> {
    return this.httpAxios
      .get('logout')
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }
}
const userService = new UserService();

export default userService;
